export type ApiError = {
    data?: {
        detail?: string;
        title?: string;
        error?: string;
    };
    error?: string;
    message?: string;
};

export function getApiErrorMessage(error: unknown): string {
    const apiError = error as ApiError;

    return (
        apiError?.data?.detail ??
        apiError?.data?.title ??
        apiError?.data?.error ??
        apiError?.error ??
        apiError?.message ??
        'Unknown error'
    );
}
